import { Component, OnInit, OnDestroy, SimpleChanges } from '@angular/core';
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
@Component({
  selector: 'app-wp98Iframe',
  templateUrl: './wp98Iframe.component.html',
  styleUrls: ['./wp98Iframe.component.scss']
})

export class Wp98IframeComponent implements OnInit, OnDestroy {
  constructor(private http: HttpClient) {
  }

  ngOnInit() {
     const iframe = document.getElementById('wp-iframe') as HTMLIFrameElement;
     iframe.src = environment.homeWP98; 
    // const accessToken = localStorage.getItem('accessToken');

    // if (!accessToken) {
    //   window.location.href = environment.home;
    //   return;
    // }

    // const headers = new HttpHeaders({
    //   Authorization: `Bearer ${accessToken}`
    // });

    // this.http.get<any>(
    //   environment.apiverifyWP98,
    //   {
    //     headers
    //   }
    // ).subscribe(
    //   response => {
    //      const iframe = document.getElementById('wp-iframe') as HTMLIFrameElement;
    //     iframe.src = environment.homeWP98 + '/?ticket=' + response.ticket;
    //   }

    // );
  }

  ngOnDestroy() {

  }

}
